import { createFileRoute } from '@tanstack/react-router';
import { PayPlanPage } from '../features/payplan/PayPlanPage';
import { validateMonthSearch } from '../lib/months';

export const Route = createFileRoute('/payplan')({
  validateSearch: validateMonthSearch,
  component: PayPlanPage,
});
